import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CommonPieChart from "../../CommonComponents/CommonPieChart";
import FecthingPage from "../../CommonComponents/FecthingPage";
import GraphHeader from "../../CommonComponents/GraphHeader";
import dayjs from "dayjs";
import ICONS from "../../../../../assets/Icons";
import {
  beneTransactionCount,
  internalTransactionCount,
} from "../../../../../redux/features/Settings/Statistics";
import CommonToast from "../../../../_utils/CommonToast";
import SvgComponent from "../../../../_utils/SVGComponent";
import Loader from "../../../../Loader/Index";

const TransactionCounts = ({ autoFetch = false, flow }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginData = useSelector((state) => state.refreshToken.data);
  const services = useSelector((state) => state.refreshToken.services);

  const {
    internalTransactionCountLoading,
    beneTransactionCountLoading,
    beneTransactionCountError,
  } = useSelector((state) => state.settingStatistics);

  const entityId = loginData?.status ? loginData?.entity?.entity_id : "";

  const toastShownRef = useRef(false);
  const [graphData, setGraphData] = useState({
    seriesData: [
      {
        label: "Unsuccessful Transactions",
        value: 20,
        color: "var(--negative-act)",
      },
      {
        label: "Successful Transactions",
        value: 70,
        color: "var(--positive-act)",
      },
    ],
    totalTransactions: 100,
    successfulTransactions: 70,
    unSuccessfulTransactions: 30,
  });

  const [selectedDays, setSelectedDays] = useState("last 7 days");
  const [selectedTxnOption, setSelectedTxnOption] = useState(
    flow === "internal" ? "internal" : "bene",
  );
  const [fetchPageEnabled, setFetchPageEnabled] = useState(!autoFetch);
  const [isError, setIsError] = useState(false);
  const [fetchPageLoading, setFetchPagefetchPageLoading] = useState(false);
  const [noData, setNoData] = useState(false);

  // Map API response to graph data
  const mapReportToGraphData = (reportData, type) => {
    const dataKey =
      type === "bene"
        ? reportData.beneficiary_transaction_count
        : reportData.internal_transaction_count;
    console.log(reportData, dataKey, selectedTxnOption);
    return {
      seriesData: [
        {
          label: "Unsuccessful Transactions",
          value: dataKey.unsuccessful_transaction,
          color: "var(--negative-act)",
        },
        {
          label: "Successful Transactions",
          value: dataKey.successful_transaction,
          color: "var(--positive-act)",
        },
      ],
      totalTransactions: dataKey.total_transaction,
      successfulTransactions: dataKey.successful_transaction,
      unSuccessfulTransactions: dataKey.unsuccessful_transaction,
    };
  };

  const handleCalculation = useCallback(
    (response, type) => {
      const reportData = response?.payload?.report_data;
      const status = response?.payload?.status;
      const errors = response?.payload?.errors;

      if (status && reportData) {
        const mappedData = mapReportToGraphData(reportData, type);
        setGraphData(mappedData);
        setIsError(false);
        setNoData(false);

        setFetchPageEnabled(false);
        toastShownRef.current = true;
      } else {
        setGraphData({
          seriesData: [
            {
              label: "Unsuccessful Transactions",
              value: 20,
              color: "var(--negative-act)",
            },
            {
              label: "Successful Transactions",
              value: 70,
              color: "var(--positive-act)",
            },
          ],
          totalTransactions: 100,
          successfulTransactions: 70,
          unSuccessfulTransactions: 30,
        });
        setFetchPageEnabled(response?.payload?.status !== 404);
        toastShownRef.current = false;
        setIsError(true);

        setIsError(true);
      }
    },
    [selectedDays, entityId],
  );

  // Fetch data function
  const fetchData = async () => {
    if (!entityId) return;

    const response = await dispatch(
      selectedTxnOption === "bene"
        ? beneTransactionCount({ entity_id: entityId, period: selectedDays })
        : internalTransactionCount({
            entity_id: entityId,
            period: selectedDays,
          }),
    );
    setFetchPagefetchPageLoading(false);
    handleCalculation(response, selectedTxnOption);
  };

  useEffect(() => {
    if (autoFetch || !fetchPageEnabled) {
      fetchData();
    }
  }, [autoFetch, fetchPageEnabled, selectedDays, selectedTxnOption]);

  const handleFetchClick = () => {
    setFetchPagefetchPageLoading(true);
    setFetchPageEnabled(false);
  };

  const getDaysFromSelectedDays = () => {
    if (selectedDays?.includes("28")) return 28;
    if (selectedDays?.includes("7")) return 7;
    return 7; // default
  };

  const getUnsuccesfulDaysFromSelectedDays = () => {
    if (selectedDays?.includes("28")) return 28;
    if (selectedDays?.includes("7")) return 7;
    return 7; // default
  };

  const getLastNDaysRange = (n = 7) => {
    const days = Number(n) || 7;
    return {
      startDate: dayjs()
        .subtract(days - 1, "day")
        .startOf("day")
        .unix(),
      endDate: dayjs().endOf("day").unix(),
    };
  };

  return (
    <div
      className={`w-width-full flex flex-col bg-primary-card rounded-border-radius-md ${noData ? "h-graphic-square-height-lg" : ""}`}
    >
      <GraphHeader
        handlingOptionsRequired={[
          { type: "days", setterState: setSelectedDays },
          { type: "txnOption", setterState: setSelectedTxnOption },
        ]}
        titleText={noData ? "Statistics" : "Transactions count"}
        autoFetch={autoFetch}
        flow={flow}
      />

      <div className="flex flex-col relative">
        <FecthingPage
          autoFetch={autoFetch}
          fetchPageEnabled={!autoFetch && fetchPageEnabled}
          loading={
            internalTransactionCountLoading ||
            beneTransactionCountLoading ||
            fetchPageLoading
          }
          errorData={beneTransactionCountError}
          isError={isError}
          handleFunction={handleFetchClick}
        />

        <div className={`w-width-full py-padding-md flex justify-center `}>
          <CommonPieChart dataArray={graphData.seriesData} />
        </div>

        <div className="w-width-full bg-primary-nav rounded-b-border-radius-md overflow-hidden">
          <div className="flex flex-col Qsmd:flex-row w-width-full justify-between">
            <div
              className="flex w-width-full px-padding-md py-padding-sm justify-between items-center global-hover-white relative z-z-index-content cursor-pointer Qsmd:rounded-b-border-radius-md Qsmd:rounded-bl-border-radius-md Qsmd:rounded-br-none flex-shrink"
              onClick={() => {
                if (selectedTxnOption === "bene") {
                  if (
                    services?.includes("VBeneficiaryTxn") ||
                    services?.includes("Admin")
                  ) {
                    const days = getDaysFromSelectedDays();
                    navigate(
                      "/beneficiary_transaction_dashboard/beneficiary_transaction_view_all",
                      {
                        state: {
                          startDateLocationState: dayjs()
                            .subtract(days - 1, "day")
                            .startOf("day")
                            .unix(),
                          endDateLocationState: dayjs().endOf("day").unix(),
                        },
                      },
                    );
                  } else {
                    navigate("/feature_not_assigned", {
                      state: { unavailableService: "VBeneficiaryTxn,Admin" },
                    });
                  }
                } else if (selectedTxnOption === "internal") {
                  if (
                    services?.includes("IVScheduledTxn") ||
                    services?.includes("Admin")
                  ) {
                    const days = getDaysFromSelectedDays();
                    navigate(
                      "/internal_transaction_dashboard/internal_transaction_view_all",
                      {
                        state: {
                          startDateLocationState: dayjs()
                            .subtract(days - 1, "day")
                            .startOf("day")
                            .unix(),
                          endDateLocationState: dayjs().endOf("day").unix(),
                        },
                      },
                    );
                  } else {
                    navigate("/feature_not_assigned", {
                      state: { unavailableService: "IVScheduledTxn,Admin" },
                    });
                  }
                }
              }}
            >
              <div className="flex gap-gap-md items-center">
                <div className="text-text-secondary text-font-xxs">
                  Total transactions :
                </div>
                <div className="text-text-primary text-font-xxs font-semibold">
                  {fetchPageEnabled
                    ? autoFetch
                      ? "N/A"
                      : "-"
                    : graphData.totalTransactions.toLocaleString("en-US")}
                </div>
              </div>

              <div className="w-icon-sm h-icon-sm ml-margin-md">
                <SvgComponent
                  url={
                    "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                  }
                  color={"var(--text-primary)"}
                  height={"var(--icon-sm)"}
                  width={"var(--icon-sm)"}
                  alt="Arrow"
                />
              </div>
            </div>
            <div className="border-primary-bg border-border Qsmd:my-margin-sm Qsmd:mx-margin-base mx-margin-md"></div>

            <div
              className="flex w-width-full px-padding-md py-padding-sm justify-between items-center global-hover-white relative z-z-index-content cursor-pointer Qsmd:rounded-b-border-radius-md Qsmd:rounded-bl-none Qsmd:rounded-br-none flex-shrink"
              onClick={() => {
                if (selectedTxnOption === "bene") {
                  if (services?.includes("VBeneficiaryTxn")) {
                    const days = getDaysFromSelectedDays();

                    navigate(
                      "/beneficiary_transaction_dashboard/beneficiary_transaction_view_all",
                      {
                        state: {
                          DistributionDashBoard: true,
                          distribution_lifecycle_status:
                            "distribution_complete",
                          startDateLocationState: dayjs()
                            .subtract(days - 1, "day")
                            .startOf("day")
                            .unix(),
                          endDateLocationState: dayjs().endOf("day").unix(),
                        },
                      },
                    );
                  } else {
                    navigate("/feature_not_assigned", {
                      state: { unavailableService: "VBeneficiaryTxn" },
                    });
                  }
                } else if (selectedTxnOption === "internal") {
                  if (services?.includes("VInternalTxn")) {
                    const days = getDaysFromSelectedDays();
                    navigate(
                      "/internal_transaction_dashboard/internal_transaction_view_all",
                      {
                        state: {
                          distribution_lifecycle_status:
                            "distribution_complete",
                          DistributionDashBoard: true,
                          startDateLocationState: dayjs()
                            .subtract(days - 1, "day")
                            .startOf("day")
                            .unix(),
                          endDateLocationState: dayjs().endOf("day").unix(),
                        },
                      },
                    );
                  } else {
                    navigate("/feature_not_assigned", {
                      state: { unavailableService: "VInternalTxn" },
                    });
                  }
                }
              }}
            >
              <div className="flex gap-gap-md items-center">
                <div className="text-text-secondary text-font-xxs">
                  Successful transactions :
                </div>
                <div className="text-positive-act text-font-xxs font-semibold">
                  {fetchPageEnabled
                    ? autoFetch
                      ? "N/A"
                      : "-"
                    : graphData.successfulTransactions.toLocaleString("en-US")}
                </div>
              </div>

              <div className="w-icon-sm h-icon-sm ml-margin-md">
                <SvgComponent
                  url={
                    "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                  }
                  color={"var(--text-primary)"}
                  height={"var(--icon-sm)"}
                  width={"var(--icon-sm)"}
                  alt="Arrow"
                />
              </div>
            </div>

            <div className="border-primary-bg border-border Qsmd:my-margin-sm Qsmd:mx-margin-base mx-margin-md"></div>

            <div
              className="flex w-width-full px-padding-md py-padding-sm justify-between items-center relative z-z-index-content  Qsmd:rounded-b-border-radius-md Qsmd:rounded-bl-none Qsmd:rounded-br-border-radius-md flex-shrink"

              // Refactored onClick
              // onClick={() => {
              //   const days = getUnsuccesfulDaysFromSelectedDays();
              //   const { startDate, endDate } = getLastNDaysRange(days);

              //   if (selectedTxnOption === "bene") {
              //     if (
              //       services?.includes("CBeneficiaryTxn") ||
              //       services?.includes("Admin")
              //     ) {
              //       navigate(
              //         "/beneficiary_transaction_dashboard/recreate_beneficiary_transaction_dashboard",
              //         {
              //           state: {
              //             isDashboradCheck: true,
              //             startDateLocationState: startDate,
              //             endDateLocationState: endDate,
              //           },
              //         },
              //       );
              //     } else {
              //       navigate("/feature_not_assigned", {
              //         state: { unavailableService: "CBeneficiaryTxn,Admin" },
              //       });
              //     }
              //   } else if (selectedTxnOption === "internal") {
              //     if (
              //       services?.includes("CInternalTxn") ||
              //       services?.includes("Admin")
              //     ) {
              //       navigate(
              //         "/internal_transaction_dashboard/recreate_internal_transaction_dashboard",
              //         {
              //           state: {
              //             isDashboradCheck: true,
              //             startDateLocationState: startDate,
              //             endDateLocationState: endDate,
              //           },
              //         },
              //       );
              //     } else {
              //       navigate("/feature_not_assigned", {
              //         state: { unavailableService: "CInternalTxn,Admin" },
              //       });
              //     }
              //   }
              // }}
            >
              <div className="flex gap-gap-md items-center">
                <div className="text-text-secondary text-font-xxs">
                  Unsuccessful transactions :
                </div>
                <div className="text-error text-font-xxs font-semibold">
                  {fetchPageEnabled
                    ? autoFetch
                      ? "N/A"
                      : "-"
                    : graphData.unSuccessfulTransactions.toLocaleString(
                        "en-US",
                      )}
                </div>
              </div>

              {/* <div className="w-icon-sm h-icon-sm ml-margin-md">
                  <SvgComponent
                    url={
                      "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                    }
                    color={"var(--text-primary)"}
                    height={"var(--icon-sm)"}
                    width={"var(--icon-sm)"}
                    alt="Arrow"
                  />
                </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionCounts;
